export default __webpack_public_path__ + "static/og-bt-1de27777a8717c558c50989597909644.jpg";